<template>
    <div class="finance">
        <navs></navs>
        <div class="financeBox">
            <p class="bigTitle">金融保险</p>
            <p class="smallTitle">FINANCE AND INSURANCE</p>
        </div>
        <div class="financeInfo">
           <div class="titles">保险业务：货运险、车船险</div>
           <p class="collectSub">
               平台通过保险经纪公司与各大保险公司网销系统直接对接，用户足不出户，通过手机即可实现7*24小时在线保费测算、投保支付、查询电子保单、电子发票等功能。同时享受平台极低的渠道费率及平台补贴，让保险触手可及
            </p>
            <div class="collectImg"></div>
        </div>
          <!--数据采集-->
        <div class="shipIntro">
           <div class="titles">供应链金融</div>
           <p class="collectSub">
               中小企业融资难、费率高等问题突出，严重制约产业发展。平台与银行及金融机构合作，为信誉优良的企业或个人提供金融服务
            </p>
            <div class="collectImg"></div>
        </div>
        <div class="shipIntro">
           <div class="titles">主要产品：运费垫款、融资租赁</div>
           <p class="collectSub">
               用户提交申请后，风控部门根据客户的申请资金、应付账款、账期、交易对象、信用记录、名下资产等方面进行风险评估，提供部分或全额资金垫付，让企业轻装上阵，降低业务门槛
            </p>
            <div class="collectImg1"></div>
        </div>
        <div class="shipIntro" style="border:none">
           <div class="titles">智能风控</div>
           <p class="collectSub">
              针对融资租赁类业务，平台研发了智能风险管控系统对融资车辆或船舶的资产管理逐渐采用信息化、可视化的管理；帮助金融保险公司监管贷中车船的运行情况、经营状况、航行轨迹等，提升对资产的管控能力，降低不诚信借贷人失联为金融机构带来的损失，减低了不良资产的损耗率，保障托盘资金安全
            </p>
            <div class="collectImg2"></div>
        </div>



        <foot></foot>
       <rightC></rightC>
    </div>
</template>
<script>
import navs from '@/components/nav/head';
import foot from '@/components/nav/footer'
import rightC from '@/components/nav/rightFloat'
export default {
    name:'finance',
    data(){
        return{
          current: 0
        }
    },
    components:{
     navs,foot,rightC
    },
    created(){

    }
}
</script>
<style lang='less' rel='stylesheet/less' >
   @rem:16rem;
   @col-f:#fff;
   .financeBox{
       width: 100%;
       height: 160/@rem;
       background: url('../assets/jin-b.png');
       background-repeat: no-repeat;
       background-position: center center;
       background-size: ceil(100%) ceil(100%);
       align-items: center;
       p{
           text-align: center;
           color: @col-f;
           font-size: 22/@rem;
           padding-top: 48/@rem;
           margin: 0;
           font-weight: 400;
       }
       .smallTitle{
           text-align: center;
           color: @col-f;
           font-size: 10/@rem;
           padding-top:10/@rem;
           font-weight: 300;

       }
   }
  .financeInfo{
       padding: 22/@rem 16/@rem;
       padding-bottom: 0;
       background:rgba(248,249,250,1);
    .titles{
       font-size: 16/@rem;
       text-align: center;
       color:  #333;

  }
      .collectSub{
          font-size: 10/@rem;
          color: #666;
        //    text-align: justify;
        //   text-align-last: center;
          text-align: center;
          line-height: 16/@rem;

      }
      .collectImg{
            width: 100%;
            height: 188/@rem;
            background: url('../assets/jin_phone.png');
            background-repeat: no-repeat;
            background-position: center bottom;
            background-size: 140/@rem 168/@rem;
      }
  }
  .shipIntro{
       padding: 22/@rem 0;
       margin: 0 16/@rem;
       border-bottom: 1px solid #E3E9EF;
    .titles{
       font-size: 16/@rem;
       text-align: center;
       color:  #333;

  }
      .collectSub{
          font-size: 10/@rem;
          color: #666;
        //     text-align: justify;
        //   text-align-last: center;
          text-align: center;
          line-height: 16/@rem;

      }
      .collectImg{

            width: 100%;
            height: 184/@rem;
            background: url('../assets/jin_pic1.png');
            background-repeat: no-repeat;
            background-position: center center;
            background-size: 208/@rem 134/@rem;
      }
       .collectImg1{

            width: 100%;
            height: 19.24rem;
            background: url('../assets/jin_pic2.png');
            background-repeat: no-repeat;
            background-position: center center;
            background-size: 15.5rem 17.75rem;;
      }
       .collectImg2{

            width: 100%;
            height: 244/@rem;
            background: url('../assets/jin_pic3.png');
            background-repeat: no-repeat;
            background-position: center center;
            background-size: 168/@rem 194/@rem;
      }


  }
  .swipeBox{
      height: 13.2rem;
  }
 .hangBox{
       width: 100%;
       height: 310/@rem;
       background-image: url('../assets/hang-bg.png');
       background-repeat: no-repeat;
       background-position: center center;
       background-size: ceil(100%) ceil(100%);


   .beiName{
       font-weight: bold;
       font-size: 14/@rem;
       text-align: center;
       color: #333;
       padding-top: 26/@rem;
       padding-bottom: 14/@rem
   }
   .beiInner{
       width: 131/@rem;
       height: 170/@rem;
       background: #fff;
       margin-left: 20/@rem;
       text-align: center;

       .beiImg{
           width: 28/@rem;
           padding-top: 12/@rem;
       }
        .beiImg1{
           width: 18/@rem;
           padding-top: 12/@rem;
       }
       .beiImg2{
           width: 26/@rem;
           padding-top: 12/@rem;
       }
         .beiImg3{
           width: 26/@rem;
           padding-top: 12/@rem;
       }
       .beiLine{
           height: 0.2rem;
           background-image: url('../assets/hang-line.png');
            background-repeat: no-repeat;
            background-position: center center;
            background-size: 1.4rem 0.2rem;
            margin-bottom: 0.4rem;
       }
       .beiTitle{
          font-size:10/@rem;
          font-weight: 800;
          color: #333;
          margin: 0
       }
       .beiIntro{
          font-size:9/@rem;
          color: #666;
          margin: 0 ;
          padding: 10/@rem 14/@rem;
        //  text-align: justify;
          text-align: left;
          line-height: 16/@rem
       }
     }
   }
</style>



// WEBPACK FOOTER //
// src/components/finance.vue